import { makeApiCall } from './core';
import type { AiConversationMessage, AiConversationSource } from '@ruta/shared';

export interface AiConversationSummary {
  id: string;
  title: string;
  messages: AiConversationMessage[];
  createdAt: string;
  updatedAt: string;
  /** Which app the chat was started in — undefined on pre-existing chats. */
  source?: AiConversationSource;
}

export async function fetchAiConversations(): Promise<AiConversationSummary[]> {
  const res = await makeApiCall<{ data: { conversations: AiConversationSummary[] } }>(
    'GET',
    '/assistant/conversations',
  );
  return res.data.conversations;
}

export async function saveAiConversation(conversation: AiConversationSummary): Promise<void> {
  await makeApiCall('PUT', `/assistant/conversations/${conversation.id}`, {
    title: conversation.title,
    messages: conversation.messages,
    createdAt: conversation.createdAt,
    updatedAt: conversation.updatedAt,
    // Only claim 'webapp' for a chat created here; echo the origin of a loaded chat.
    source: conversation.source ?? 'webapp',
  });
}

export async function deleteAiConversation(id: string): Promise<void> {
  await makeApiCall('DELETE', `/assistant/conversations/${id}`);
}
